import { Controller } from "@hotwired/stimulus"

// Enables horizontal scrolling with mouse wheel on flowboards.
// When over a column without vertical scroll or outside columns,
// converts vertical wheel movement to horizontal scroll.
export default class extends Controller {
  connect() {
    this.boundHandleWheel = this.handleWheel.bind(this)
    this.element.addEventListener('wheel', this.boundHandleWheel, { passive: false })
  }
  disconnect() {
    this.element.removeEventListener('wheel', this.boundHandleWheel)
  }

  handleWheel(event) {
    if (event.deltaY === 0) return

    const hasHorizontalScroll = this.element.scrollWidth > this.element.clientWidth
    if (!hasHorizontalScroll) return

    const scrollableColumn = event.target.closest('.kanban-column-scrollable')

    if (scrollableColumn) {
      const hasVerticalScroll = scrollableColumn.scrollHeight > scrollableColumn.clientHeight

      if (hasVerticalScroll) {
        return
      }
    }

    // Convert vertical wheel to horizontal scroll
    event.preventDefault()
    this.element.scrollLeft += event.deltaY
  }
}
